import SortableWrapperContainer from '../../../containers/dnd/SortableWrapperContainer'

const ListDropSortableItems = ({
    listId, 
    items, 
    order,
    itemType,
    dndType,
    params,
    basicUrl,
    dataType,
    basePreviewUrl,
    ChildSwitchItem,
    cinemaId, 
    canEdit, 
    flyerPk,
    canDelete,
    reorderItem, 
    deleteItem
}) => {

    return (
        <div className="item-drag-container">
            <ul className="grid-container">
                {order.map((itemId, index) => {
                    const itemData = items[itemId]

                    if(!itemData) {
                        return ''
                    }

                    return (
                        <li key={index} className="item-drag">
                            <SortableWrapperContainer
                                index={index} 
                                moveItem={reorderItem}
                                listId={'list-' + listId}
                                dndType={dndType ? dndType : itemType}
                            >
                                <ChildSwitchItem
                                    listId={listId}
                                    itemId={itemId}
                                    basePreviewUrl={basePreviewUrl}
                                    itemType={itemType}
                                    dataType={dataType}
                                    itemData={itemData}
                                    isSelected={false}
                                    cinemaId={cinemaId}
                                    canEdit={canEdit}
                                    canDelete={canDelete}
                                    flyerPk={flyerPk}
                                    params={params}
                                    basicUrl={basicUrl}
                                    deleteItem={deleteItem}
                                />
                            </SortableWrapperContainer>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default ListDropSortableItems